import { useModalStore } from '@/stores/useModalStore';
import { apolloClient } from '@/graphql/client';
import { ref } from 'vue';
import { PlaylistObject } from '@/types/modalStoreTypes';
import { getPlaylistLight } from '@/graphql/queries';

export default function useGetPlaylistLight() {
  const modalStore = useModalStore();
  const result = ref<PlaylistObject | null>(null);
  const queryState = ref('idle' as 'idle' | 'loading' | 'error' | 'success');

  const requestPlaylistLight = async (playlistId: string) => {
    if (playlistId) {
      try {
        queryState.value = 'loading';
        const { data } = await apolloClient.query({
          query: getPlaylistLight,
          variables: { id: playlistId },
          fetchPolicy: 'network-only',
        });
        result.value = data.playlist;
        queryState.value = 'success';
        setTimeout(() => {
          queryState.value = 'idle';
        }, 1500);
      } catch (error) {
        console.error('useGetPlaylistLight Query Error', error);
        queryState.value = 'error';
        setTimeout(() => {
          queryState.value = 'idle';
        }, 1500);
        return;
      }
    }

    // set playlist data
    if (result.value) {
      modalStore.setPlaylistModalData(
        'sharePlaylistModal',
        result.value as PlaylistObject,
      );
    }
  };

  return { requestPlaylistLight, queryState };
}
